import React from 'react';
import {
    Form,
    Row,
    Col,
    Label,
    FormGroup,
    Button, Input,
    FormText, Container
} from "reactstrap";
import "./style.css"
import SelectListComponent from '../utils/selectList';

const months = [
    { label: "January", Id: 1 },
    { label: "February", Id: 2 },
    { label: "March", Id: 3 },
    { label: "April", Id: 4 },
    { label: "May", Id: 5 },
    { label: "June", Id: 6 },
    { label: "July", Id: 7 },
    { label: "August", Id: 8 },
    { label: "September", Id: 9 },
    { label: "October", Id: 10 },
    { label: "November", Id: 11 },
    { label: "December", Id: 12 }
];

const ManifestUploadPanel = ({componentErrorMessages, requesting, airlines, airlineId, file, selectedMonth, handleSelectChange, handleFileChange, handleUpload, handleSearch}) => {
    return (
        <div>
            <Form onSubmit={e => e.preventDefault()}>
                <Container>
                    <Row>
                        <Col sm="4">
                            <FormGroup className={"mb-1 " +(componentErrorMessages.airlineId ? 'has-danger' : '')}>
                                <Label>Airline</Label>
                                <SelectListComponent placeholder={'Select airline...'} data={airlines} valueKey='Id' textField='Name' selectValue={airlineId} onValueChange={(event) => { handleSelectChange(event, 'airlineId') } } />
                                { componentErrorMessages.airlineId && <FormText color="danger"> {componentErrorMessages.airlineId }</FormText> }
                            </FormGroup>
                        </Col>

                        <Col sm="4">
                            <FormGroup className={"mb-1 " +(componentErrorMessages.selectedMonth ? 'has-danger' : '')}>
                                <Label>Month</Label>
                                <SelectListComponent placeholder={'Select month...'} data={months} valueKey='Id' textField='label' selectValue={selectedMonth} onValueChange={(event) => { handleSelectChange(event, 'selectedMonth') } } />
                                { componentErrorMessages.selectedMonth && <FormText color="danger"> {componentErrorMessages.selectedMonth }</FormText> }
                            </FormGroup>
                        </Col>
                        <Col sm="3">
                             <FormGroup className={"mb-1 " +(componentErrorMessages.file ? 'has-danger' : '')}>
                                <Label>File</Label>
                                <Input type="file" onClick={(event) => { event.target.value = null} } onChange={(event) => handleFileChange(event)}/>
                                { componentErrorMessages.file && <FormText color="danger"> {componentErrorMessages.file }</FormText> }
                            </FormGroup>
                        </Col>
                        <Col sm="1">
                            <FormGroup className={"mb-1 " +(componentErrorMessages.File ? 'has-danger' : '')}>
                                <Label>&nbsp;</Label><br/>
                                <Button disabled={ requesting } className="btn-avi-primary pull-left" onClick={handleUpload}>Upload</Button> &nbsp;
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">
                        <FormGroup className={"mb-1 " +(componentErrorMessages.File ? 'has-danger' : '')}>
                                <Label>&nbsp;</Label><br/>
                                <Button disabled={ requesting } className="btn-avi-primary pull-left search" onClick={handleSearch}>Search</Button> &nbsp;
                            </FormGroup>
                        </Col>
                    </Row>
                </Container>

            </Form>
        </div>
    );
};

export default ManifestUploadPanel;



// WEBPACK FOOTER //
// ./src/views/uploadManifest/upload-panel.js